module.exports = __webpack_public_path__ + "img/converifai-logo-dark.e07d1fa0.svg";